
/* MARTIOR full-width predictive search panel */
document.addEventListener('DOMContentLoaded', () => {
  const overlay = document.querySelector('[data-search-overlay]');
  const input = document.querySelector('[data-search-input]');
  const results = document.querySelector('[data-search-results]');
  const home = document.querySelector('[data-search-home]');
  const triggers = [...document.querySelectorAll('[data-search-open]')];
  if (!overlay || !input || !results || !home || !triggers.length) return;
  let previousFocus, timer, controller;
  function open() {
    previousFocus = document.activeElement;
    overlay.hidden = false;
    document.body.classList.add('search-open');
    triggers.forEach(b => b.setAttribute('aria-expanded', 'true'));
    requestAnimationFrame(() => input.focus());
  }
  function close() {
    overlay.hidden = true;
    document.body.classList.remove('search-open');
    triggers.forEach(b => b.setAttribute('aria-expanded', 'false'));
    clearTimeout(timer);
    if (controller) controller.abort();
    if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
  }
  triggers.forEach(b => b.addEventListener('click', open));
  overlay.querySelectorAll('[data-search-close]').forEach(b => b.addEventListener('click', close));
  document.addEventListener('keydown', e => {
    if (overlay.hidden) return;
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') {
      const els = [...overlay.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])')].filter(el => el.getClientRects().length);
      const first = els[0], last = els[els.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  const make = (tag, cls, content) => {
    const el = document.createElement(tag);
    if (cls) el.className = cls;
    if (content !== undefined) el.textContent = content;
    return el;
  };
  async function search(q) {
    if (controller) controller.abort();
    controller = new AbortController();
    results.replaceChildren(make('p', 'search-message', 'Searching…'));
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const url = root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
      const response = await fetch(url, {signal: controller.signal, headers: {'Accept': 'application/json'}});
      if (!response.ok) throw new Error('Search request failed');
      const data = await response.json();
      const products = data.resources && data.resources.results && data.resources.results.products || [];
      results.replaceChildren();
      if (!products.length) {
        results.append(make('p', 'search-message', 'No jewelry found. Try a different search.'));
        return;
      }
      results.append(make('p', 'search-group-title', 'SUGGESTED PIECES'));
      const grid = make('div', 'search-product-grid');
      products.forEach(product => {
        const card = make('a', 'search-product');
        card.href = product.url;
        const photo = make('div', 'search-product-photo');
        const imageUrl = product.featured_image && (product.featured_image.url || product.featured_image);
        if (imageUrl) {
          const img = make('img');
          img.src = imageUrl;
          img.alt = product.title || '';
          img.loading = 'lazy';
          photo.append(img);
        }
        card.append(photo, make('span', 'search-product-name', product.title));
        if (product.price) card.append(make('span', 'search-product-price', (typeof product.price === 'number' ? new Intl.NumberFormat(undefined, {style:'currency',currency:(window.Shopify && window.Shopify.currency && window.Shopify.currency.active)||'USD'}).format(product.price / 100) : product.price)));
        grid.append(card);
      });
      results.append(grid);
      const link = make('a', 'search-view-all', 'VIEW ALL RESULTS');
      link.href = root + 'search?q=' + encodeURIComponent(q) + '&type=product';
      results.append(link);
    } catch (err) {
      if (err.name !== 'AbortError') {
        results.replaceChildren(make('p', 'search-message', 'Suggestions are temporarily unavailable. Press Search to view all results.'));
      }
    }
  }
  input.addEventListener('input', () => {
    clearTimeout(timer);
    const q = input.value.trim();
    home.hidden = Boolean(q);
    results.hidden = !q;
    if (!q) { if (controller) controller.abort(); results.replaceChildren(); return; }
    timer = setTimeout(() => search(q), 250);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const openButton = document.querySelector('[data-nav-toggle]');
  const overlay = document.querySelector('[data-menu-overlay]');
  if (!openButton || !overlay) return;
  let returnFocus = null;
  const closeButtons = overlay.querySelectorAll('[data-nav-close]');
  // A single open submenu keeps the luxury navigation concise on small screens.
  const accordionGroups = [...overlay.querySelectorAll('[data-martior-menu-group]')];
  accordionGroups.forEach(group => group.addEventListener('toggle', () => {
    if (group.open) accordionGroups.forEach(other => { if (other !== group) other.open = false; });
  }));
  function openMenu() {
    returnFocus = document.activeElement;
    overlay.hidden = false;
    document.body.classList.add('martior-menu-open');
    openButton.setAttribute('aria-expanded', 'true');
    overlay.querySelector('[data-nav-close]').focus();
  }
  function closeMenu() {
    overlay.hidden = true;
    accordionGroups.forEach(group => { group.open = false; });
    document.body.classList.remove('martior-menu-open');
    openButton.setAttribute('aria-expanded','false');
    if (returnFocus) returnFocus.focus();
  }
  openButton.addEventListener('click', openMenu);
  closeButtons.forEach(b => b.addEventListener('click', closeMenu));
  document.addEventListener('keydown', event => {
    if (overlay.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); closeMenu(); }
    if (event.key === 'Tab') {
      const focusable = [...overlay.querySelectorAll('a[href],button:not([disabled]),summary')].filter(e => e.getClientRects().length);
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {event.preventDefault();last.focus();}
      else if (!event.shiftKey && document.activeElement === last) {event.preventDefault();first.focus();}
    }
  });
});

/* Native Shopify filters — side drawer with overlay, keyboard close, and accessible focus. */
document.addEventListener('DOMContentLoaded', () => {
  const panel = document.querySelector('[data-filter-panel]');
  const trigger = document.querySelector('[data-filter-open]');
  const backdrop = document.querySelector('[data-filter-backdrop]');
  if (!panel || !trigger || !backdrop) return;
  const closeButton = panel.querySelector('[data-filter-close]');
  const focusable = () => [...panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), summary')].filter(el => el.getClientRects().length);
  function show() {
    backdrop.hidden = false;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden','false');
    trigger.setAttribute('aria-expanded','true');
    document.body.classList.add('martior-filters-open');
    (closeButton || panel).focus();
  }
  function hide() {
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden','true');
    trigger.setAttribute('aria-expanded','false');
    backdrop.hidden = true;
    document.body.classList.remove('martior-filters-open');
    trigger.focus();
  }
  trigger.addEventListener('click', () => panel.classList.contains('is-open') ? hide() : show());
  if (closeButton) closeButton.addEventListener('click', hide);
  backdrop.addEventListener('click', hide);
  document.addEventListener('keydown', event => {
    if (!panel.classList.contains('is-open')) return;
    if (event.key === 'Escape') { event.preventDefault(); hide(); }
    if (event.key === 'Tab') {
      const els = focusable();
      if (!els.length) { event.preventDefault(); panel.focus(); return; }
      if (event.shiftKey && document.activeElement === els[0]) { event.preventDefault(); els[els.length-1].focus(); }
      else if (!event.shiftKey && document.activeElement === els[els.length-1]) {event.preventDefault(); els[0].focus(); }
    }
  });
  panel.querySelectorAll('[data-price-filter]').forEach(container => {
    const min=container.querySelector('[data-price-min]'), max=container.querySelector('[data-price-max]');
    const rMin=container.querySelector('[data-range-min]'), rMax=container.querySelector('[data-range-max]');
    const fill=container.querySelector('[data-price-fill]');
    if(!min||!max||!rMin||!rMax||!fill) return;
    const ceiling=Math.max(1,Number(container.dataset.max)||1);
    const clamp=v=>Math.min(ceiling,Math.max(0,Number(v)||0));
    function render(source) {
      let low=clamp(source==='min'?min.value:source==='rmin'?rMin.value:min.value);
      let high=clamp(source==='max'?max.value:source==='rmax'?rMax.value:max.value);
      if(low>high) {if(source==='min'||source==='rmin') high=low; else low=high;}
      min.value=low; max.value=high; rMin.value=low; rMax.value=high;
      fill.style.left=(low/ceiling*100)+'%'; fill.style.right=(100-high/ceiling*100)+'%';
    }
    min.addEventListener('change',()=>render('min')); max.addEventListener('change',()=>render('max'));
    rMin.addEventListener('input',()=>render('rmin')); rMax.addEventListener('input',()=>render('rmax'));
    render();
  });
});


/* MARTIOR Drop the Diamond Plinko game */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-plinko-section]').forEach(section => {
    const trigger = section.querySelector('[data-plinko-open]');
    const invite = section.querySelector('[data-plinko-invite]');
    const dismiss = section.querySelector('[data-plinko-dismiss]');
    const expand = section.querySelector('[data-plinko-expand]');
    const overlay = section.querySelector('[data-plinko-overlay]');
    const modal = section.querySelector('.martior-plinko-modal');
    const closeButtons = section.querySelectorAll('[data-plinko-close]');
    const dropButton = section.querySelector('[data-plinko-drop]');
    const board = section.querySelector('[data-plinko-board]');
    const diamond = section.querySelector('[data-plinko-diamond]');
    const slots = [...section.querySelectorAll('[data-plinko-slot]')];
    const result = section.querySelector('[data-plinko-result]');
    const winLabel = section.querySelector('[data-plinko-win-label]');
    const winCaption = section.querySelector('[data-plinko-win-caption]');
    const claim = section.querySelector('[data-plinko-claim]');
    const copy = section.querySelector('[data-plinko-copy]');
    const codeRow = section.querySelector('[data-plinko-code-row]');
    const codeValue = section.querySelector('[data-plinko-code]');
    if (!trigger || !overlay || !dropButton || !board || !diamond || !slots.length) return;
    // One play every five 24-hour days, persisted between theme revisions.
    const storageKey = 'martior-plinko-cooldown-v1';
    const fiveDaysMs = 5 * 24 * 60 * 60 * 1000;
    const safeGet = key => { try { return localStorage.getItem(key); } catch(e) { return null; } };
    const safeSet = (key,value) => { try { localStorage.setItem(key,String(value)); } catch(e) {} };
    const recordedTime = () => Number(safeGet(storageKey + ':playedAt') || 0);
    const isCoolingDown = () => { const time = recordedTime(); return time > 0 && (Date.now() - time) < fiveDaysMs; };
    const readWin = () => {
      if (!isCoolingDown()) return null;
      const raw = safeGet(storageKey + ':winningSlot');
      const index = raw === null ? null : Number(raw);
      return index !== null && Number.isInteger(index) && index >= 0 && index < slots.length ? index : null;
    };
    // The small X minimizes the prompt to a compact diamond bubble; it never removes access.
    const minimizedKey = storageKey + ':inviteMinimizedForSession';
    const wasDismissed = () => { try { return sessionStorage.getItem(minimizedKey) === 'yes'; } catch(e) { return false; } };
    function setMinimized(value, remember = true) {
      if (remember) { try { if (value) sessionStorage.setItem(minimizedKey,'yes'); else sessionStorage.removeItem(minimizedKey); } catch(e) {} }
      if (invite) invite.classList.toggle('is-minimized', value);
      if (expand) expand.hidden = !value;
      if (dismiss) dismiss.hidden = value;
      if (trigger) trigger.hidden = value;
    }
    setMinimized(wasDismissed(), false);
    if (dismiss) dismiss.addEventListener('click', () => setMinimized(true));
    if (expand) expand.addEventListener('click', () => { setMinimized(false); trigger.focus(); });
    const updateTrigger = () => {};
    let lastFocus = null;
    let animating = false;

    function open() {
      lastFocus = document.activeElement;
      overlay.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('martior-plinko-open');
      requestAnimationFrame(() => { layoutGuides(); dropButton.focus(); });
      safeSet(storageKey + ':promptedAt', Date.now());
      const saved = readWin();
      if (saved !== null) { showWin(saved, false); dropButton.disabled = true; } else { dropButton.disabled = false; }
    }
    function close() {
      overlay.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('martior-plinko-open');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }
    function clearHighlights() {
      slots.forEach(slot => slot.classList.remove('is-winning'));
    }
    // Visualize the actual bin dividers as soon as the game opens.
    function layoutGuides() {
      const area=board.getBoundingClientRect();
      if(!area.width)return;
      const tiles=slots.map(slot=>slot.getBoundingClientRect());
      const guides=board.querySelector('[data-plinko-guides]');
      if(!guides||tiles.some(tile=>!tile.width))return;
      const top=tiles[0].top-area.top-23;
      guides.replaceChildren();
      for(let i=0;i<tiles.length-1;i++){
        const x=(tiles[i].right+tiles[i+1].left)/2-area.left;
        const bar=document.createElement('span');
        bar.className='martior-plinko-guide';
        bar.style.left=`${x}px`;
        bar.style.top=`${top}px`;
        bar.style.height='27px';
        guides.appendChild(bar);
      }
    }
    window.addEventListener('resize',()=>{if(!overlay.hidden)layoutGuides();});
    // Keep the real diamond SVG parked inside the winning card, including on repeat visits.
    function parkDiamond(index, animated = false) {
      const slot = slots[index];
      if (!slot) return;
      const incoming = animated && diamond.parentElement === board ? diamond.getBoundingClientRect() : null;
      const rect = slot.getBoundingClientRect();
      const size = Math.min(23, Math.max(15, rect.height * .37));
      slot.appendChild(diamond);
      diamond.classList.add('is-visible', 'is-parked');
      diamond.style.transition = 'none';
      diamond.style.transform = 'none';
      diamond.style.willChange = '';
      diamond.style.width = `${size}px`;
      diamond.style.height = `${size}px`;
      diamond.style.bottom = 'auto';
      diamond.style.left = incoming ? `${incoming.left - rect.left}px` : `${(rect.width-size)/2}px`;
      diamond.style.top = incoming ? `${incoming.top - rect.top}px` : `${rect.height-size-3}px`;
      if (incoming) {
        // Wait for the DOM reparent to paint before smoothly settling the gem inside the card.
        requestAnimationFrame(() => requestAnimationFrame(() => {
          diamond.style.transition = 'left .22s ease-out, top .22s ease-out';
          diamond.style.left = `${(slot.clientWidth-size)/2}px`;
          diamond.style.top = `${slot.clientHeight-size-3}px`;
        }));
      }
    }
    function resetDiamondForNewDrop() {
      if (diamond.parentElement !== board) board.appendChild(diamond);
      diamond.classList.remove('is-parked','is-visible');
      diamond.removeAttribute('style');
    }
    function encodeDiscountUrl(code, redirectPath) {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const normalized = redirectPath || '/collections/all';
      const target = normalized.startsWith('http') ? normalized : normalized;
      return code ? `${root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(target)}` : (target || '/');
    }
    function showWin(index, persist=true) {
      const slot = slots[index];
      if (!slot) return;
      clearHighlights();
      slot.classList.add('is-winning');
      parkDiamond(index, persist);
      result.hidden = false;
      winLabel.textContent = slot.dataset.label || 'Your offer';
      winCaption.textContent = slot.dataset.caption || 'Apply this offer to your order.';
      claim.href = encodeDiscountUrl(slot.dataset.code, slot.dataset.redirect);
      claim.textContent = slot.dataset.code ? 'Apply this offer' : 'Continue shopping';
      if (codeRow && codeValue) {
        codeRow.hidden = !slot.dataset.code;
        codeValue.textContent = slot.dataset.code || '';
      }
      if (slot.dataset.code) {
        copy.textContent = 'Copy code';
        copy.hidden = false;
        copy.dataset.code = slot.dataset.code;
      } else {
        copy.hidden = true;
      }
      if (persist) {
        safeSet(storageKey + ':winningSlot', index);
        safeSet(storageKey + ':playedAt', Date.now());
        updateTrigger();
      }
    }
    // V42: a real fixed-timestep 2D simulation. The diamond accelerates under
    // gravity, ricochets from the visible pegs and hits physical slot dividers.
    // There is no scripted zigzag, late-peg magnet, prize homing, or preselected win.
    async function animateDrop() {
      if (animating) return;
      animating = true;
      resetDiamondForNewDrop();
      clearHighlights();
      result.hidden = true;
      dropButton.disabled = true;

      const boardRect = board.getBoundingClientRect();
      const w = boardRect.width, h = boardRect.height;
      const diameter = diamond.getBoundingClientRect().width || 26;
      // Diamond outline is narrower than its square SVG viewport.
      const radius = diameter * .43;
      const rowEls = [...board.querySelectorAll('.martior-plinko-peg-row')];
      const pegRows = rowEls.map(row =>
        [...row.querySelectorAll('.martior-plinko-peg')].map(el => {
          const box = el.getBoundingClientRect();
          return {x:box.left+box.width/2-boardRect.left,
                  y:box.top+box.height/2-boardRect.top,
                  el, r:Math.max(box.width,box.height)/2 + 1.5};
        })
      );
      const pegs = pegRows.flatMap((row,rowIndex) => row.map(peg => ({...peg,rowIndex})));
      const tiles = slots.map(el => {
        const box=el.getBoundingClientRect();
        return {left:box.left-boardRect.left, right:box.right-boardRect.left,
                center:box.left+box.width/2-boardRect.left,
                top:box.top-boardRect.top,height:box.height};
      });
      if (!w || !h || !pegs.length || tiles.length<2) {
        // Avoid a locked button if a browser momentarily measures a hidden board.
        const middle=Math.floor(slots.length/2);
        showWin(middle, true);
        animating=false;
        return;
      }

      const separators=tiles.slice(0,-1).map((tile,i) => (tile.right+tiles[i+1].left)/2);
      const chuteTop=tiles[0].top-23;
      const floorY=Math.min(h-radius-8,tiles[0].top+Math.min(25,tiles[0].height-radius-8));
      layoutGuides();
      // Fixed dt, actual momentum and realistic restitution on each peg.
      const dt=1/180;
      const gravity=470*(h/500);
      const maxVelocity=790*(h/500);
      const minX=radius+5,maxX=w-radius-5;
      const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const rand=(a,b)=>a+Math.random()*(b-a);
      const ball={x:w/2+rand(-Math.min(w*.065,25),Math.min(w*.065,25)),
                  y:Math.max(radius+13, Math.min(29,pegRows[0][0].y-radius-24)),
                  vx:rand(-85,85)*(w/460),vy:0,angle:rand(-14,14),omega:rand(-115,115)};
      let t=0, lastMovementAt=0, bestY=ball.y, hasLanded=false;
      let landingAt=0, floorBounces=0;
      const touches=Array(pegRows.length).fill(0);
      const flashEvents=[];
      const frames=[];
      let impacts=0, horizontalTravel=0, directionChanges=0, oldVxSign=Math.sign(ball.vx);
      const pose=()=>({x:ball.x,y:ball.y,angle:ball.angle});
      frames.push(pose());
      function channel(x){
        for(let i=0;i<separators.length;i++)if(x<separators[i])return i;
        return slots.length-1;
      }
      function collidePeg(peg){
        const dx=ball.x-peg.x,dy=ball.y-peg.y;
        const contact=radius+peg.r;
        if(Math.abs(dx)>contact||Math.abs(dy)>contact)return;
        const distance=Math.hypot(dx,dy);
        if(distance>=contact)return;
        const nx=distance>.0001?dx/distance:(Math.random()<.5?-1:1)*.15;
        const ny=distance>.0001?dy/distance:-Math.sqrt(1-nx*nx);
        const overlap=contact-distance+.08;
        ball.x+=nx*overlap;
        ball.y+=ny*overlap;
        const approach=ball.vx*nx+ball.vy*ny;
        if(approach>=-9)return;
        const impact=-(1+0.66)*approach;
        ball.vx+=impact*nx;
        ball.vy+=impact*ny;
        // A slight rotational/tangential impulse adds realistic glance-off spin.
        const tx=-ny,ty=nx;
        const sliding=ball.vx*tx+ball.vy*ty-ball.omega*radius*Math.PI/180;
        const friction=Math.max(-30,Math.min(30,-sliding*.105));
        ball.vx+=tx*friction;
        ball.vy+=ty*friction;
        ball.omega+=(-friction/Math.max(radius,5))*80;
        // A mathematically perfect head-on hit would balance forever.
        // Imperceptible physical asymmetry makes it fall left or right instead.
        if(Math.abs(nx)<.045 && ny<-.65) ball.vx+=rand(15,26)*(Math.random()<.5?-1:1);
        touches[peg.rowIndex]++;
        impacts++;
        flashEvents.push({at:frames.length,el:peg.el});
      }
      function simulateStep(){
        t+=dt;
        const priorX=ball.x;
        ball.vy=Math.min(maxVelocity,ball.vy+gravity*dt);
        ball.x+=ball.vx*dt;
        ball.y+=ball.vy*dt;
        ball.vx*=Math.exp(-.15*dt);
        ball.omega*=Math.exp(-.34*dt);
        ball.angle+=ball.omega*dt;
        horizontalTravel+=Math.abs(ball.x-priorX);
        if(ball.x<minX){ball.x=minX;ball.vx=Math.abs(ball.vx)*.70;ball.omega+=90;}
        if(ball.x>maxX){ball.x=maxX;ball.vx=-Math.abs(ball.vx)*.70;ball.omega-=90;}
        // Check only nearby rows. Every peg remains active until the stone clears it.
        if(ball.y<chuteTop+radius){
          for (const peg of pegs) {
            if(Math.abs(ball.y-peg.y)>radius+peg.r+1)continue;
            collidePeg(peg);
          }
        }
        // Real side-wall collisions at each prize-channel separator, not a
        // magnetic pull to the center of the chosen prize.
        if(ball.y+radius>=chuteTop && ball.y-radius<=floorY){
          for(const sx of separators){
            const dx=ball.x-sx;
            const penetration=radius+1.5-Math.abs(dx);
            if(penetration<=0)continue;
            // Bounce off the top rounded tip if the diamond is just entering.
            if(ball.y<chuteTop && ball.vy>0){
              const dy=ball.y-chuteTop;
              const dist=Math.hypot(dx,dy);
              if(dist<radius+2){
                let nx=dx/Math.max(.001,dist),ny=dy/Math.max(.001,dist);
                if(Math.abs(nx)<.05)nx=(Math.random()<.5?-1:1)*.08;
                const correct=radius+2-dist;
                ball.x+=nx*correct;ball.y+=ny*correct;
                const vn=ball.vx*nx+ball.vy*ny;
                if(vn<0){ball.vx-=1.35*vn*nx;ball.vy-=1.35*vn*ny;impacts++;}
              }
            } else if(ball.y>=chuteTop){
              const side=dx===0?(ball.vx>=0?1:-1):Math.sign(dx);
              ball.x=sx+side*(radius+1.5);
              if(ball.vx*side<0)ball.vx=-ball.vx*.48;
              ball.omega+=side*22;
            }
          }
        }
        const sign=Math.sign(ball.vx);
        if(sign && oldVxSign && sign!==oldVxSign)directionChanges++;
        if(sign)oldVxSign=sign;
        if(ball.y>bestY+3){bestY=ball.y;lastMovementAt=t;}
        // Safety: nudge momentum, never position. This still uses real collisions.
        if(t-lastMovementAt>1.12 && ball.y<chuteTop){
          ball.vx+=rand(50,105)*(Math.random()<.5?-1:1);
          ball.vy=Math.max(ball.vy,28);
          lastMovementAt=t;
        }
        // Final physical impact and short, damped bounce on the prize floor.
        if(ball.y>=floorY){
          ball.y=floorY;
          if(!hasLanded){
            hasLanded=true;landingAt=t;
            floorBounces++;
          }
          if(Math.abs(ball.vy)>34 && floorBounces<=2){
            ball.vy=-Math.abs(ball.vy)*.18;
          } else ball.vy=0;
          ball.vx*=.82;ball.omega*=.72;
        }
        frames.push(pose());
      }
      // Complete a single naturally chosen trajectory. No hunting through
      // candidates and no late steering to manufacture peg hits.
      const maxSteps=Math.ceil(12/dt);
      for(let i=0;i<maxSteps;i++){
        simulateStep();
        if(hasLanded && t-landingAt>.30)break;
      }
      if(!hasLanded){
        // Extremely rare numerical fallback: increase gravity, keeping peg and
        // divider collisions active and the diamond visible until it settles.
        for(let i=0;i<900&&!hasLanded;i++){
          ball.vy=Math.max(65,ball.vy);
          simulateStep();
        }
      }
      if(!hasLanded){
        // Hidden or degenerate layout: choose the x-position's actual channel.
        // The fallback is not an alternate prize-selection mechanism.
        ball.y=floorY;frames.push(pose());
      }
      const landingIndex=channel(ball.x);
      board.dataset.physicsMode='natural-gravity';
      board.dataset.lastPegHits=touches.join(',');
      board.dataset.pegImpacts=String(impacts);
      board.dataset.directionChanges=String(directionChanges);
      board.dataset.horizontalTravel=String(Math.round(horizontalTravel));
      board.dataset.simulationSeconds=t.toFixed(2);
      const durationMs=Math.max(3000,Math.min(8000,(Number(section.dataset.dropDuration)||5)*1000));
      const complete={done:false};
      function draw(p){
        diamond.style.transform=`translate3d(${(p.x-diameter/2).toFixed(2)}px,${(p.y-diameter/2).toFixed(2)}px,0) rotate(${p.angle.toFixed(2)}deg)`;
      }
      function finish(){
        if(complete.done)return;
        complete.done=true;
        showWin(landingIndex,true);
        diamond.style.willChange='';
        animating=false;
      }
      diamond.style.transition='none';
      diamond.style.willChange='transform';
      diamond.classList.add('is-visible');
      draw(frames[0]);
      if(reducedMotion){draw(frames[frames.length-1]);finish();return;}
      const last=frames.length-1;
      let animationStart=null, nextFlash=0;
      function animationFrame(now){
        if(complete.done)return;
        if(animationStart===null)animationStart=now;
        const progress=Math.min(1,(now-animationStart)/durationMs);
        const cursor=progress*last;
        const i=Math.floor(cursor),j=Math.min(last,i+1),mix=cursor-i;
        while(nextFlash<flashEvents.length && flashEvents[nextFlash].at<=cursor){
          const peg=flashEvents[nextFlash].el;
          if(peg){peg.classList.add('is-hit');setTimeout(()=>peg.classList.remove('is-hit'),140);}
          nextFlash++;
        }
        const a=frames[i],b=frames[j];
        draw({x:a.x+(b.x-a.x)*mix,y:a.y+(b.y-a.y)*mix,angle:a.angle+(b.angle-a.angle)*mix});
        if(progress>=1)finish();else requestAnimationFrame(animationFrame);
      }
      requestAnimationFrame(animationFrame);
    }
    trigger.addEventListener('click', open);
    closeButtons.forEach(btn => btn.addEventListener('click', close));
    document.addEventListener('keydown', e => {
      if (overlay.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') {
        const els = [...modal.querySelectorAll('a[href],button:not([disabled])')].filter(el => el.getClientRects().length);
        if (!els.length) return;
        const first = els[0], last = els[els.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    dropButton.addEventListener('click', async () => {
      if (animating) return;
      const saved = readWin();
      if (saved !== null) {
        showWin(saved, false);
        return;
      }
      await animateDrop();
    });

    // Invite eligible visitors after five seconds, but never reopen after they dismiss the bubble in this session.
    // Playing has a five-day cooldown; the floating invitation remains until X is pressed.
    const lastPrompted = Number(safeGet(storageKey + ':promptedAt') || 0);
    if (section.dataset.autoOpen === 'true' && !isCoolingDown() && (Date.now() - lastPrompted > fiveDaysMs)) {
      const seconds = Math.min(20, Math.max(1, Number(section.dataset.autoDelay) || 5));
      window.setTimeout(() => {
        if (document.visibilityState !== 'visible' || !overlay.hidden || wasDismissed() || isCoolingDown() || Number(safeGet(storageKey + ':promptedAt') || 0)>lastPrompted) return;
        if (document.body.classList.contains('search-open') || document.body.classList.contains('martior-menu-open') || document.body.classList.contains('martior-filters-open')) return;
        if (document.querySelector('[role="dialog"][aria-modal="true"]:not([hidden])')) return;
        open();
      }, seconds * 1000);
    }

    copy.addEventListener('click', async () => {
      const code = copy.dataset.code;
      if (!code) return;
      try {
        await navigator.clipboard.writeText(code);
        copy.textContent = 'Copied';
        setTimeout(() => copy.textContent = 'Copy code', 1400);
      } catch (e) {
        copy.textContent = code;
      }
    });
  });
});

/* MARTIOR V31: wishlist, product image gallery/zoom, and variant price sync. */
document.addEventListener('DOMContentLoaded', () => {
  const KEY = 'martior-wishlist-v1';
  const safeRead = () => {
    try {
      const data = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(data)) return [];
      return data.filter(x => x && typeof x.id === 'string' && typeof x.url === 'string').slice(0,200);
    } catch(e) { return []; }
  };
  const safeWrite = items => { try { localStorage.setItem(KEY, JSON.stringify(items)); return true; } catch(e) { return false; } };
  const grid = document.querySelector('[data-wishlist-grid]');
  const empty = document.querySelector('[data-wishlist-empty]');
  const productButtons = () => document.querySelectorAll('[data-wishlist-toggle]');
  function updateButtons() {
    const ids = new Set(safeRead().map(item=>item.id));
    productButtons().forEach(btn => {
      const saved = ids.has(String(btn.dataset.wishlistId || ''));
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      btn.setAttribute('aria-label', `${saved ? 'Remove' : 'Save'} ${btn.dataset.wishlistTitle || 'piece'} ${saved ? 'from' : 'to'} wishlist`);
      btn.title = saved ? 'Remove from wishlist' : 'Save to wishlist';
      const label = btn.querySelector('[data-wishlist-label]');
      if (label) label.textContent = saved ? 'Saved to wishlist' : 'Save to wishlist';
    });
  }
  const productUrl = raw => {try {const u=new URL(raw,location.origin);return u.origin===location.origin&&u.pathname.startsWith('/products/')?u.pathname:'/collections/all';} catch(e){return '/collections/all';}};
  function renderWishlist() {
    if (!grid) return;
    const items=safeRead();
    grid.replaceChildren();
    if (empty) empty.hidden = items.length > 0;
    for (const item of items) {
      const card=document.createElement('article');card.className='martior-wishlist-card';
      const link=document.createElement('a');link.href=productUrl(item.url);
      if (item.image && /^(https:\/\/|\/\/)/i.test(item.image)) {
        const img=document.createElement('img');img.src=item.image;img.loading='lazy';img.alt=item.title||'MARTIOR jewelry';link.append(img);
      } else { const placeholder=document.createElement('div');placeholder.className='empty-image';placeholder.textContent='MARTIOR';link.append(placeholder); }
      const title=document.createElement('h3');title.textContent=item.title||'Saved jewelry';link.append(title);
      const price=document.createElement('p');price.textContent=item.price||'';link.append(price);card.append(link);
      const remove=document.createElement('button');remove.type='button';remove.className='martior-wishlist-remove';remove.textContent='REMOVE FROM WISHLIST';
      remove.addEventListener('click',()=>{const updated=safeRead().filter(x=>x.id!==item.id);if(safeWrite(updated)){renderWishlist();updateButtons();}});
      card.append(remove);grid.append(card);
    }
  }
  document.addEventListener('click', event => {
    const btn=event.target.closest('[data-wishlist-toggle]');if(!btn)return;
    event.preventDefault();
    const id=String(btn.dataset.wishlistId||'');if(!id)return;
    const current=safeRead();const exists=current.some(item=>item.id===id);
    const next=exists?current.filter(item=>item.id!==id):[...current,{id,title:btn.dataset.wishlistTitle||'MARTIOR piece',url:btn.dataset.wishlistUrl||'',image:btn.dataset.wishlistImage||'',price:btn.dataset.wishlistPrice||''}];
    if (safeWrite(next)) {updateButtons();renderWishlist();} else {btn.title='Unable to save on this browser';}
  });
  updateButtons();renderWishlist();
  window.addEventListener('storage',event=>{if(event.key===KEY){updateButtons();renderWishlist();}});

  const images=[...document.querySelectorAll('[data-product-image]')];
  const thumbs=[...document.querySelectorAll('[data-product-thumb]')];
  const lightbox=document.querySelector('[data-product-lightbox]');
  const lightboxImage=lightbox?.querySelector('[data-lightbox-image]');
  const closeLightbox=lightbox?.querySelector('[data-lightbox-close]');
  let returnFocus=null;
  function showImage(index){
    if(index<0||index>=images.length)return;
    images.forEach((item,i)=>item.classList.toggle('is-hidden',i!==index));
    thumbs.forEach((item,i)=>{item.classList.toggle('is-active',i===index);item.setAttribute('aria-pressed',i===index?'true':'false');});
  }
  thumbs.forEach((btn,i)=>btn.addEventListener('click',()=>showImage(i)));
  images.forEach(btn=>btn.addEventListener('click',()=>{
    const img=btn.querySelector('img');if(!img||!lightbox||!lightboxImage)return;
    returnFocus=btn;lightboxImage.src=img.currentSrc||img.src;lightboxImage.alt=img.alt||'Jewelry image';lightbox.hidden=false;
    document.body.classList.add('martior-product-lightbox-open');closeLightbox?.focus();
  }));
  const hideLightbox=()=>{if(!lightbox||lightbox.hidden)return;lightbox.hidden=true;document.body.classList.remove('martior-product-lightbox-open');lightboxImage?.removeAttribute('src');returnFocus?.focus();};
  closeLightbox?.addEventListener('click',hideLightbox);
  lightbox?.addEventListener('click',event=>{if(event.target===lightbox)hideLightbox();});
  document.addEventListener('keydown',event=>{if(event.key==='Escape')hideLightbox();if(event.key==='Tab'&&lightbox&&!lightbox.hidden){event.preventDefault();closeLightbox?.focus();}});
  const variant=document.querySelector('[data-variant-selector]');
  variant?.addEventListener('change',()=>{
    const opt=variant.selectedOptions[0],input=document.querySelector('[data-variant-input]'),price=document.querySelector('[data-product-price]');
    if(input)input.value=opt?.value||'';if(price&&opt?.dataset.price)price.textContent=opt.dataset.price;
  });
});

/* MARTIOR V36 — instantly preview the chosen diamond shape. */
(() => {
  function initRingPreview(root) {
    const planners = root.matches && root.matches('.martior-ring-planner') ? [root] : [...root.querySelectorAll('.martior-ring-planner')];
    for (const planner of planners) {
      const img=planner.querySelector('[data-ring-preview-image]');
      const name=planner.querySelector('[data-ring-preview-name]');
      if(!img || !name) continue;
      function syncSelection() {
        const selected=planner.querySelector('[data-ring-shape]:checked');
        if(!selected) return;
        const source=selected.getAttribute('data-ring-photo');
        if(source && img.getAttribute('src')!==source) img.setAttribute('src',source);
        img.alt='Illustrative '+selected.value+'-cut diamond';
        name.textContent=selected.value;
      }
      if(planner.dataset.ringPreviewReady!=='true'){
        planner.dataset.ringPreviewReady='true';
        planner.addEventListener('change',event=>{
          if(event.target && event.target.matches('[data-ring-shape]')) syncSelection();
        });
      }
      syncSelection();
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>initRingPreview(document));
  else initRingPreview(document);
  document.addEventListener('shopify:section:load',event=>initRingPreview(event.target));
})();
